import { translateKeys, describeHotKey } from '@/services/hotkeys'

// swinging icon
export const animateSlow = ['animate__slow']
export const animateSlower = ['animate_slower']
export const animatedForever = [ 'animate__animated', 'animate__infinite' ]
export const swingingIcon = ['animate__swing', ...animatedForever, ...animateSlow ]
export const tadaIcon = ['animate__tada', ...animatedForever, ...animateSlow ]
export const heartBeat = ['animate__heartBeat', ...animatedForever ] // slow/slower does nothing

// common danger styling
export const dangerStyle = {
  cardVariant: () => 'danger',
  iconClass: () => swingingIcon.join(' '),
  tagClass: () => 'is-danger is-light',
  menuVariant: () => 'danger',
}

export const successStyle = {
  cardVariant: () => 'success',
  tagClass: () => 'is-success is-light',
  menuVariant: () => 'success',
}

export const stylingByMessage = {
  ServiceMonitoring: {
    icon: () => 'gear',
    iconClass: () => 'has-text-info',
    menuVariant: () => 'info',
    content: (_, m) => ({ text: `${m['Properties.State']}: ${m['Properties.DisplayName']}` })
  },
  WelcomeMessage: {
    cardVariant: () => 'success',
    icon: () => 'door-open',
    menuVariant: () => 'success',
    content: (_, m) => {
      const r = m.Result
      if ((r||'') === '') return ''
      const text = r.split(';').filter(i => i !== '').map(i => i.split(':').join(': ')).join(', ')
      return { text }
    }
  },
  DiagnosticTest: {
    iconClass: () => 'has-text-warning',
    tagClass: () => 'is-warning',
    menuVariant: () => 'warning'
  },
  slackInteractions: {
    icon: () => ['fab', 'slack'],
    iconClass: () => 'has-text-danger',
    title: () => ({ text: 'Slack Chat Activity' }),
    // content: () => ({ text: 'User was active on Slack Desktop.' })
  },
  HotKey: {
    icon: () => 'keyboard',
    content: (_, m) => {
      const keysPressed = translateKeys(m['KnownHotKey.KeyData'].split(',').map(k => k.trim()))
      const action = describeHotKey(m['KnownHotKey.Action'])
      return { text: `${keysPressed.join(' + ')} • ${action}` }
    }
  },
  WindowFocusChanged: {
    title: () => ({ text: "User's Focus Changed" }),
    icon: () => 'window-restore',
  },
  BrowserEvent: {
    icon: () => ['fab', 'safari'],
    iconClass: () => 'has-text-info',
    title: (_, m) => ({ text: `Browser: ${m.BrowserEvent}` }),
    content: () => 'Graph.page.title'
  }
}

export function styleOptionByMessage (n, option, defaultValue) {
  const m = n.metaData
  const style = stylingByMessage[n.message]
  if (style && style[option] && typeof(style[option]) === 'function') {
    return style[option](n, m)
  }
  return defaultValue
}